import $ from "jquery";

export default () => {
  let locations = [
    [39.020408, -1.901866, 4],
    [49.318988, -79.772961, 5],
    [50.897097, 40.637198, 3],
    [59.035713, 14.797354, 2],
    [-44.1229489, -17.7642468, 1]
  ];

  const myLatlng = { lat: 45.06, lng: -22 };
  const map = new google.maps.Map(document.getElementById('map'), {
    zoom: 2,
    center: myLatlng,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: "poi.business",
        stylers: [
          {
            visibility: "off"
          }
        ]
      },
      {
        featureType: "poi.park",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "off"
          }
        ]
      }
    ]
  });

  const image = {
    url: 'images/map-marker.svg',
    size: new google.maps.Size(71, 71),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(17, 34),
    scaledSize: new google.maps.Size(25, 25)
  };

  let marker, 
    i;
  for (i = 0; i < locations.length; i++) {
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(locations[i][0], locations[i][1]),
      icon: image,
      map: map
    });
  }
}



// WEBPACK FOOTER //
// app/scripts/components/map.js